import { useMemo } from 'react';
import { useNavigate } from 'react-router';

import { ButtonProps } from '@mui/material';

import { AppButton } from 'src/components';
import useFeatures from 'src/hooks/useFeatures';
import useSubscriptions from 'src/hooks/useSubscriptions';
import { PACKAGES_CATALOG } from 'src/pages/saasSubscribe/utils/packages-catalog';
import { useMutationProgrammeCreate } from 'src/resources/queries/programmes.queries';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { lowerCase } from 'src/utils/stringFormatter';
import { useProgramme } from 'src/hooks/use-programme';
import { ProgrammeActivityType, ProgrammeType } from 'src/resources/api/programme/types.api';
import useMerchant from 'src/hooks/useMerchant';

//
//

export const CreateProgramme = (props: ButtonProps & { text?: string }) => {
  const navigate = useNavigate();

  const { merchant } = useMerchant();
  const { isCreateManagedProgrammeFeature } = useFeatures();
  const { prefferedBasketAsync } = useProgramme();

  const { currentPlan } = useSubscriptions();

  const getProgrammeActivityType = useMemo(() => {
    return PACKAGES_CATALOG?.find((c) => c?.code === currentPlan?.packageCode)?.activityType;
  }, [currentPlan?.packageCode]);

  const createProgramme = useMutationProgrammeCreate({
    onSuccess: (data) => {
      navigate(PATH_DASHBOARD.programs.program(lowerCase(data.type), data.code));
    },
  });

  //

  return isCreateManagedProgrammeFeature ? (
    <AppButton
      variant="contained"
      loading={createProgramme.isPending || prefferedBasketAsync?.isLoading}
      {...props}
      onClick={(event) => {
        createProgramme.mutate({
          merchantCode: merchant?.code || '',
          name: 'Untitled Programme',
          type: ProgrammeType.MANAGED,
          activityType: getProgrammeActivityType || ProgrammeActivityType.NONE,
          preferredBasketCode: prefferedBasketAsync.data?.code,
        });
        props.onClick?.(event);
      }}
    >
      {props?.text || 'Create new programme'}
    </AppButton>
  ) : null;
};
